<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
      <input
        type="checkbox"
        class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
        formControlName="sandbox"
        id="onlyup-sandbox"
      />
      <label
        for="onlyup-sandbox"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.integrations.sandboxMode' | translate }}
      </label>
    </div>

    <fieldset [formGroupName]="'in'" class="gw-space-y-4">
      <legend class="gw-block gw-text-sm gw-font-medium gw-text-text-primary">
        {{ 'features.integrations.cashIn' | translate }}
      </legend>

      <div class="gw-mb-4">
        <label
          for="onlyup-pixKey"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.pixKey' | translate }}
        </label>
        <input
          id="onlyup-pixKey"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="pixKey"
          [placeholder]="'features.integrations.pixKeyPlaceholder' | translate"
        />
        <small
          *ngIf="
            form.get('in')?.get('pixKey')?.invalid &&
            form.get('in')?.get('pixKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.pixKeyRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-clientId"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientId' | translate }}
        </label>
        <input
          id="onlyup-in-clientId"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="clientId"
          [placeholder]="
            'features.integrations.clientIdPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('in')?.get('clientId')?.invalid &&
            form.get('in')?.get('clientId')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientIdRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-clientSecret"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientSecret' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="onlyup-in-clientSecret"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="clientSecret"
            [placeholder]="
              'features.integrations.clientSecretPlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>
        <small
          *ngIf="
            form.get('in')?.get('clientSecret')?.invalid &&
            form.get('in')?.get('clientSecret')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientSecretRequired' | translate }}
        </small>
      </div>

      <hr class="gw-my-4 gw-border-border-normal" />

      <p class="gw-text-sm gw-font-medium gw-text-text-primary gw-mb-4">
        {{ 'features.integrations.mtlsConfiguration' | translate }}
      </p>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-mtlsCertFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsCert' | translate }}
        </label>
        <input
          id="onlyup-in-mtlsCertFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'in', 'mtlsCert')"
          accept=".pem,.crt,.cer,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('in', 'mtlsCert')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('in', 'mtlsCert')] }}
        </small>
        <small
          *ngIf="
            form.get('in')?.get('mtlsCert')?.invalid &&
            form.get('in')?.get('mtlsCert')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsCertRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-mtlsKeyFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsKey' | translate }}
        </label>
        <input
          id="onlyup-in-mtlsKeyFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'in', 'mtlsKey')"
          accept=".key,.pem,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('in', 'mtlsKey')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('in', 'mtlsKey')] }}
        </small>
        <small
          *ngIf="
            form.get('in')?.get('mtlsKey')?.invalid &&
            form.get('in')?.get('mtlsKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsKeyRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-mtlsPfxFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsPfx' | translate }}
        </label>
        <input
          id="onlyup-in-mtlsPfxFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'in', 'mtlsPfx')"
          accept=".pfx"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('in', 'mtlsPfx')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('in', 'mtlsPfx')] }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-in-mtlsPassphrase"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsPassphrase' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="onlyup-in-mtlsPassphrase"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="mtlsPassphrase"
            [placeholder]="
              'features.integrations.mtlsPassphrasePlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>
      </div>
    </fieldset>

    <fieldset class="gw-mt-4" [formGroupName]="'out'">
      <legend
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-4"
      >
        {{ 'features.integrations.cashOut' | translate }}
      </legend>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-clientId"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientId' | translate }}
        </label>
        <input
          id="onlyup-out-clientId"
          type="text"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          formControlName="clientId"
          [placeholder]="
            'features.integrations.clientIdPlaceholder' | translate
          "
          autocomplete="off"
        />
        <small
          *ngIf="
            form.get('out')?.get('clientId')?.invalid &&
            form.get('out')?.get('clientId')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientIdRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-clientSecret"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.clientSecret' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="onlyup-out-clientSecret"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="clientSecret"
            [placeholder]="
              'features.integrations.clientSecretPlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>
        <small
          *ngIf="
            form.get('out')?.get('clientSecret')?.invalid &&
            form.get('out')?.get('clientSecret')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.clientSecretRequired' | translate }}
        </small>
      </div>

      <hr class="gw-my-4 gw-border-border-normal" />

      <p class="gw-text-sm gw-font-medium gw-text-text-primary gw-mb-4">
        {{ 'features.integrations.mtlsConfiguration' | translate }}
      </p>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-mtlsCertFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsCert' | translate }}
        </label>
        <input
          id="onlyup-out-mtlsCertFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'out', 'mtlsCert')"
          accept=".pem,.crt,.cer,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('out', 'mtlsCert')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('out', 'mtlsCert')] }}
        </small>
        <small
          *ngIf="
            form.get('out')?.get('mtlsCert')?.invalid &&
            form.get('out')?.get('mtlsCert')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsCertRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-mtlsKeyFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsKey' | translate }}
        </label>
        <input
          id="onlyup-out-mtlsKeyFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'out', 'mtlsKey')"
          accept=".key,.pem,.txt"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('out', 'mtlsKey')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('out', 'mtlsKey')] }}
        </small>
        <small
          *ngIf="
            form.get('out')?.get('mtlsKey')?.invalid &&
            form.get('out')?.get('mtlsKey')?.touched
          "
          class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
        >
          {{ 'features.integrations.mtlsKeyRequired' | translate }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-mtlsPfxFile"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsPfx' | translate }}
        </label>
        <input
          id="onlyup-out-mtlsPfxFile"
          type="file"
          class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
          (change)="onFileChange($event, 'out', 'mtlsPfx')"
          accept=".pfx"
        />
        <small
          class="gw-text-text-secondary gw-text-sm gw-mt-1 gw-block"
          *ngIf="fileNames[fileNameKey('out', 'mtlsPfx')]"
        >
          {{ 'features.integrations.selected' | translate }}:
          {{ fileNames[fileNameKey('out', 'mtlsPfx')] }}
        </small>
      </div>

      <div class="gw-mb-4">
        <label
          for="onlyup-out-mtlsPassphrase"
          class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
        >
          {{ 'features.integrations.mtlsPassphrase' | translate }}
        </label>
        <div class="gw-relative">
          <input
            id="onlyup-out-mtlsPassphrase"
            [type]="showSecret ? 'text' : 'password'"
            class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
            formControlName="mtlsPassphrase"
            [placeholder]="
              'features.integrations.mtlsPassphrasePlaceholder' | translate
            "
            autocomplete="off"
          />
          <button
            type="button"
            class="gw-absolute gw-right-2 gw-top-2 gw-p-1 gw-text-text-secondary hover:gw-text-text-primary"
            (click)="showSecret = !showSecret"
          >
            <gatewee-icon
              [icon]="showSecret ? '@tui.eye-off' : '@tui.eye'"
              size="16px"
            ></gatewee-icon>
          </button>
        </div>
      </div>
    </fieldset>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        type="button"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
